import React from 'react';
import numericFunction from "../../../utils/NumericFunction";

const OrderId = ({
                   sendData,
                   setSendData,
                   initialData,
                   componentData,
                   setComponentData,
                 }) => {
  return (
    <div className="divgroup">
      <label htmlFor="sendData__orderId">کد سفارش</label>
      <input
        id={'sendData__orderId'}
        type="text"
        className="form-control"
        placeholder=""
        value={numericFunction.e2p(sendData.orderId)}
        onChange={(e) => {

          let value = e.target.value
          value = numericFunction.p2e(value)
          setSendData({orderId: value.trim()})

        }}
      />

    </div>

  );
};

export default OrderId;
